import { StatCard } from "@/components/admin/payouts/primitives";

export interface TherapistCounts {
  pending: number | undefined;
  active: number | undefined;
  deactivated: number | undefined;
  rejected: number | undefined;
}

export function TherapistsStats({ counts }: { counts: TherapistCounts }) {
  const loading =
    counts.pending === undefined ||
    counts.active === undefined ||
    counts.rejected === undefined;

  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card px-4 py-3.5 shadow-sm sm:px-5 sm:py-4"
          >
            <div className="h-3.5 w-20 animate-pulse rounded bg-muted" />
            <div className="mt-2.5 h-7 w-16 animate-pulse rounded bg-muted/60 sm:h-8" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <StatCard
        label="Na čekanju"
        value={String(counts.pending)}
        tone={(counts.pending ?? 0) > 0 ? "amber" : "neutral"}
      />
      <StatCard label="Aktivni" value={String(counts.active)} tone="primary" />
      <StatCard label="Deaktivirani" value={String(counts.deactivated)} />
      <StatCard label="Odbijeni" value={String(counts.rejected)} />
    </div>
  );
}
